export default __webpack_public_path__ + "static/media/BITI-BNB.a4836adf.png";